import './global-styles.scss'

import { createBrowserHistory } from 'history'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'

import { initThemeFromUrl } from 'initializers/theme'
import { createStore } from 'create-store'
import { reducers } from 'reducers'

import { App } from './app'

document.addEventListener('DOMContentLoaded', async () => {
  const history = createBrowserHistory()
  const store = createStore(reducers, {}, history)
  initThemeFromUrl()

  createRoot(document.getElementById('root')).render(createElement(App, {
    store,
    history
  }))
})
